import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, unref as _unref, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "font-sourcesanspro-semibold text-l2" }
const _hoisted_2 = { class: "flex px-6 py-3 w-full justify-between" }
const _hoisted_3 = { class: "text-base" }
const _hoisted_4 = { class: "text-right" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "text-base font-sourcesanspro-semibold" }
const _hoisted_7 = { class: "text-right" }
const _hoisted_8 = { class: "text-sm font-sourcesanspro-semibold" }
const _hoisted_9 = { class: "font-sourcesanspro-semibold text-l2" }
const _hoisted_10 = { class: "font-sourcesanspro-semibold text-l2" }

import { computed, PropType } from 'vue';
import { IonItem, IonList } from '@ionic/vue';
import { useI18n } from 'vue-i18n';
import useUtils from '@/shared/composables/useUtils';
import type { TransactionItem } from '@/shared/interfaces/transaction';


export default /*@__PURE__*/_defineComponent({
  __name: 'TopUpItemsSummary',
  props: {
	items: {
		type: Array as PropType<TransactionItem[]>,
		required: true,
	},
	totalPrice: {
		type: Number,
		required: true,
	},
	walletReceives: {
		type: Number,
		required: false,
		default: undefined,
	},
	walletReceivesCurrency: {
		type: String,
		required: false,
		default: '€',
	},
	title: {
		type: String,
		required: true,
	},
	totalTitle: {
		type: String,
		required: true,
	},
	variant: {
		type: String,
		default: 'dark',
	},
},
  setup(__props) {

const props = __props;

const { t } = useI18n();
const { convertToCurrency } = useUtils();

const hasTopUpFee = computed(() => props.walletReceives !== undefined && props.walletReceives < props.totalPrice);

const isDark = computed(() => props.variant === 'dark');

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(IonList), {
    class: _normalizeClass(isDark.value ? 'backdrop-blur-xl bg-anykrowd-gray/20 text-white rounded-xl mb-4' : 'bg-white rounded-xl mb-4')
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(isDark.value ? 'flex px-6 py-4 items-center text-white' : 'flex px-6 py-4 items-center text-dark-blue')
      }, [
        _createElementVNode("span", _hoisted_1, _toDisplayString(__props.title), 1)
      ], 2),
      _createElementVNode("div", {
        class: _normalizeClass(isDark.value ? 'border-y border-y-white/5' : 'border-y border-y-slate-200')
      }, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.items, (item, idx) => {
          return (_openBlock(), _createBlock(_unref(IonItem), {
            key: idx,
            lines: "none",
            class: _normalizeClass(['ion-no-padding font-sourcesanspro-regular', isDark.value ? 'text-white' : 'text-dark-blue/70'])
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("div", null, [
                  _createElementVNode("div", _hoisted_3, _toDisplayString(item.description), 1)
                ]),
                _createElementVNode("div", _hoisted_4, [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(item.currency || '€') + " " + _toDisplayString(_unref(convertToCurrency)(item.itemPrice)), 1)
                ])
              ])
            ]),
            _: 2
          }, 1032, ["class"]))
        }), 128))
      ], 2),
      (hasTopUpFee.value)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(isDark.value ? 'border-b border-b-white/5' : 'border-b border-b-slate-200')
          }, [
            _createElementVNode("div", {
              class: _normalizeClass(['flex px-6 py-3 w-full justify-between', isDark.value ? 'text-white/70' : 'text-dark-blue/70'])
            }, [
              _createElementVNode("div", null, [
                _createElementVNode("div", _hoisted_6, _toDisplayString(_unref(t)('topup.wallet_receives')), 1)
              ]),
              _createElementVNode("div", _hoisted_7, [
                _createElementVNode("span", _hoisted_8, _toDisplayString(`${__props.walletReceivesCurrency}${_unref(convertToCurrency)(__props.walletReceives)}`), 1)
              ])
            ], 2)
          ], 2))
        : _createCommentVNode("", true),
      _createElementVNode("div", {
        class: _normalizeClass(['flex px-6 py-4 items-center justify-between', isDark.value ? 'text-white' : 'text-dark-blue'])
      }, [
        _createElementVNode("span", _hoisted_9, _toDisplayString(__props.totalTitle), 1),
        _createElementVNode("span", _hoisted_10, _toDisplayString(`€${_unref(convertToCurrency)(__props.totalPrice)}`), 1)
      ], 2)
    ]),
    _: 1
  }, 8, ["class"]))
}
}

})